import { render, staticRenderFns } from "./DeleteTender.vue?vue&type=template&id=4fda7fff"
import script from "./DeleteTender.vue?vue&type=script&lang=js"
export * from "./DeleteTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports